//document ready
$(function() {
    
    $('body').on('click', '.filters-container .toggle-custom', function () {
        if ($(this).hasClass('active')) {
            $('.filters-container').removeClass('filter-active');
            $(this).removeClass('active');
            $(this).nextAll('.toggle_list-custom').css('display', 'none').removeClass("opened");
            $('.filterDisabler').addClass("opened");
        }
        else {
            $('.toggle-custom').removeClass('active');
            $('.toggle_list-custom').css('display', 'none');
            $('.filters-container').addClass('filter-active');
            $(this).addClass('active');
            $(this).nextAll('.toggle_list-custom').css('display', 'flex').addClass("opened");
            if ($(window).width() > 798) {
                $(this).nextAll('.toggle_list-custom').css('position', 'relative');
                $(this).nextAll('.toggle_list-custom').css('padding', '0');
            }
            $('.filterDisabler').removeClass("opened");
        }

    });

    

    $('body').on('click', '.filterDisabler', function(){
        $(this).parent().find(".active .clear-active-filter").click();
    });

    
    $('body').on('click', '[data-clear-filter]', function(){
        $('.filters-container').removeClass('filter-active');
    });
    
    $('body').on('click', '[data-clear-filters]', function(){
        $('[data-option-filter]').each(function(){
            $(this).find('input').prop('checked',false);
        });
    });


    $('body').on('change', '[data-option-filter] input', function(){
        $('.filters-container').removeClass('filter-active');
        setFilterMobileButton();
    });

    


    var setFilterMobileButton = function(){
        var isFilterActive = false;
        $('[data-option-filter] input').each(function(){
            if ( $(this).is(':checked') ){
                isFilterActive = true;
            }
        });
        if( isFilterActive ){
            $('.fixed-inside-filters').addClass('filters-active');
        }
        else{
            $('.fixed-inside-filters').removeClass('filters-active');
        }
    }

    setFilterMobileButton();

    $('body').on('click', '.fixed-filters, [data-close-filter-screen]', function(){
        if($(this).hasClass('opened')){
            $('.filters-container').removeClass('active');
            $('.fixed-filters, [data-close-filter-screen]').removeClass('opened');
            var scrollTarget = $(this).attr('data-scroll-to');
            if(typeof scrollTarget !== 'undefined'){
                goToPos(scrollTarget);                
            }
        }
        else{
            $('.filters-container').addClass('active');
            $('.fixed-filters, [data-close-filter-screen]').addClass('opened');
        }
    });

});
